<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="標題" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索標題"></el-input>
						</el-form-item>
						
						<el-form-item label="類型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="系统通知" :value="1"></el-option>
								<el-option label="後台發送" :value="2"></el-option>
							</el-select>
						</el-form-item>
					
						<el-form-item label="發送時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
			<!-- 	<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column> -->
				
				<el-table-column align="center" width="130" prop="notice_no" label="編號">
				</el-table-column>
			
				<el-table-column align="center" prop="title" label="發送標題">
								<template slot-scope="scope">
									<!-- <div v-if="scope.row.title.length > 20">
										{{ scope.row.title.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.title }}
									</div> -->
									{{ scope.row.title }}
								</template>
					</el-table-column>

				
				<!-- <el-table-column align="center" width="80" prop="content"  label="發送内容">
					<template slot-scope="scope">
						<el-popover trigger="click" style="cursor: pointer;" placement="top">
						  <p style="width: 300px;">{{ scope.row.content }}</p>
						  <div slot="reference" class="name-wrapper">
							<el-tag size="medium" @click="submit(scope.row)">查看</el-tag>
						  </div>
						</el-popover>
					  </template>
				</el-table-column> -->

				<el-table-column align="center" width="100" prop="content" label="公告內容">
						<template slot-scope="scope">
							<div slot="reference" style="cursor: pointer;"  class="name-wrapper"  @click="openDialog(scope.row)">
									<el-tag size="medium">查看</el-tag>
								</div>
						</template>
					</el-table-column>
				
				
				<el-table-column align="center"  width="230" prop="type"  label="類型">
					<template slot-scope="v">
						<span class="text-success" v-if="v.row.type==2">後台發送 - {{v.row.send_name}}</span>
						<span class="text-warning" v-if="v.row.type==3">機構發送 - {{v.row.send_name}}</span>
						<el-tag size="medium" style="margin-left: 15px;cursor: pointer;" @click="reply(v.row)">聯絡</el-tag>
					</template>

				</el-table-column>
				
				<el-table-column align="center" width="120" prop="check_status"  label="是否已讀">
					<template slot-scope="v">
						<span style="color: red;" v-if="v.row.check_status==0">未讀</span>
						<span class="text-success" v-if="v.row.check_status==1">已讀</span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="create_time" width="200" label="發送時間">
				</el-table-column>

				<el-table-column align="center" prop="endTime" width="100" label="張貼日期至">
				</el-table-column>
			
			</el-table>
		</div>

	
		<el-dialog :close-on-click-modal="false" top="5vh" :visible.sync="dialogVisible" :width="layout.is_phone?'90%':'70%'" @close="closeDialog">
			<span slot="title">
				<span style="font-size: 2em;">{{ dialogTitle }}</span>
				<div class="dialog-meta" style="margin-bottom: 10px;">
				<p>
					<span class="text-success" v-if="dialogArr.type==2">後台發送 - {{dialogArr.send_name}}</span>
					<span class="text-warning" v-if="dialogArr.type==3">機構發送 - {{dialogArr.send_name}}</span><strong style="margin-left: 40px;">{{ dialogArr.staTime }}</strong> </p>
				
				<p>{{ dialogArr.msg }}</p>
			</div>
			</span>
			<div ref="dialogContent" style="max-height: 70vh; overflow: auto;">
				
			
						<!-- 使用 v-html 渲染 HTML 内容 -->
						<div v-html="dialogContent"></div>
					</div>
						<span slot="footer" class="dialog-footer" >
							<el-button @click="closeDialog">關閉</el-button>
						</span>
				
					</el-dialog>


		<el-dialog :close-on-click-modal="false"  
			title="聯絡" 
			:visible.sync="createModel" 
			top="5vh" 
			:width="layout.is_phone ? '90%' : '80%'" 
			class="custom-dialog"
			>
			<el-form :rules="rules" ref="formEdit" :model="NotForm" :label-width="layout.is_phone ? '80px' : '100px'" :label-position="layout.is_phone ? 'top' : 'left'">
			<template> 
					<el-descriptions v-if="NotForm.type == 3" class="margin-top "
						title="機構信息"
						:column="2"
						style="margin-bottom: 30px;"
						border>
							
							<!-- 電話 -->
						<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-mobile-phone"></i>
							電話
						</template>
						{{ NotForm.ins.phone }}
						</el-descriptions-item>

						<!-- 電郵 -->
						<el-descriptions-item>
							
						<template slot="label">
							<i class="el-icon-message"></i>
							電郵
						</template>
						<div style="width: 200px;">{{ NotForm.ins.email }}</div>
						
						</el-descriptions-item>

						<!-- 名稱 -->
						<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-user"></i>
							名稱
						</template>
						{{ NotForm.ins.name }}
						</el-descriptions-item>

						<!-- 地址 -->
						<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-position"></i>
							地址
						</template>
						{{ NotForm.ins.local }}
						</el-descriptions-item>

						<!-- 簡介 -->
						<el-descriptions-item>
						<template slot="label">
							<i class="el-icon-tickets"></i>
							簡介
						</template>
						{{ NotForm.ins.info }}
						</el-descriptions-item>
					</el-descriptions>

					<el-form-item v-else label="接收人"  prop="sendtype">
						Let's GO客服
					</el-form-item> 
			</template>
				<!-- 顶部信息展示区 -->
			

				<!-- 回复標題輸入 -->
				<el-form-item label="標題" prop="reply_title">
				<el-input 
					type="text" 
					v-model="NotForm.reply_title"
					maxlength="50"
					show-word-limit
					placeholder="標題"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>

				<!-- 回复内容輸入 -->
				<el-form-item label="内容" prop="reply_content">
				<el-input 
					type="textarea" 
					:rows="3" 
					v-model="NotForm.reply_content"
					show-word-limit
					placeholder="内容"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>
			</el-form>

			<!-- 底部按钮 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取消</el-button>
				<el-button type="primary" :loading="submitLoading" @click="submit">發送</el-button>
			</div>
		</el-dialog>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>
		<el-dialog  :close-on-click-modal="false" :visible.sync="dialogTitleVisible" title="標題">
			<p>{{ fullTitle }}</p>
		</el-dialog>
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				dialogTitleVisible: false,
				fullTitle: '',

				loading: false,      
				dialogVisible: false,      // 控制對話框顯示
				dialogContent: '' ,         // 存储當前对话框的内容
				dialogTitle: '' ,         // 存储當前对话框的標題
				dialogArr:[],

				rules: {
					reply_content: [{
							required: true,
							message: "內容不能為空",
							trigger: 'blur',
						},
					],
					reply_title: [{
							required: true,
							message: "標題不能為空",
							trigger: 'blur',
						},
					],
				},
				
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					content:'',
					type:-1,
					all_type:-1,
					ins_type:-1,
					sendtype:-1,
					time: [],
				},
				model_title: 'Notice',
				auth_val: 'Notice',
				preUrl: "data/noticeList", //列表地址
				addUrl: "data/setNoticeRead", //回覆郵件
				editStatusUrl: "data/setNoticeRead", //修改狀態地址
				tableData: [],
				form: {
					id: 0,
					title:'',
					content:"",
					sendtype:0,
					user_id:0,
					ins_id:0,
					ins_type:0,
					all_type:0,
					school_id:0,
					icon:'',
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				submitLoading: false,
				NotForm:[],
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['school_list','inst_list','user_list']);
		},
		methods: {
			reply(e){
				// 初始化表單數據
				this.NotForm = {
					notice_type: 1,
					type: e.type,
					id: e.id,
					send_name: e.send_name,
					ins: e.ins_data,
					reply_content: '',
					reply_title: '',
				};
				this.createModel = true;
			},
			changeType(){
				if(this.form.sendtype==2){
					if(this.form.all_type==1){
						
					}
				}
			},
			// 顯示完整標題内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.school_list = list.school
					this.inst_list = list.inslist
					this.user_list = list.userlist
			
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {
				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit(res) {
				this.$refs.formEdit.validate(res => {
					if (res) {
						this.submitLoading = true
						this.axios.post('/admin/data/replyUserEmail', 
							this.NotForm,
						{
							token: true,
						}).then(res => {
							let all = res.data;
							console.log(all)
							if (all.code == 1) {
									this.$message({
										message: '操作完成',
										type: 'success'
									});
							}
							this.submitLoading = false
							this.createModel = false
						}).catch(err => {
							// 失敗
							this.$message.error('操作失敗');
							this.submitLoading = false
						})
					}
				})
			},
			
			openDialog(row) {
				this.dialogContent = row.content; // 设置要顯示的 HTML 内容
				this.dialogTitle = row.title; // 设置要顯示的 HTML 内容
				this.dialogArr = row; // 设置要顯示的 HTML 内容
				this.dialogVisible = true;    // 顯示对话框
				if(row.check_status == 0){
					// this.form.id = row.id;
					this.someMethod(row)
					// this.getList()
				}
			},
			async someMethod(row) {
				this.form.id = row.id;
				await this.changeStatus(this.form, 3, false, true); // 確保这里正確等待异步操作完成
				return new Promise(resolve => {
					setTimeout(() => {
						this.getList();
						resolve(); // 如果你需要在外部等待 someMethod 完成（包括延遲），保留这行
					}, 1000); // 延遲時間，以毫秒为單位，这里设置为1秒
				});
			},
			closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
				this.dialogTitle = '';      // 清空内容
				this.dialogArr = [];      // 清空内容
			},
		
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.logo = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
				return isJPG && isLt2M;
			  },
			
			// 打开模态框
			openModel(e, type) {
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						title: e.title,
						content: e.content,
						sendtype:e.sendtype,
						school_id:Number(e.appoint_id),
						ins_id:Number(e.appoint_id),
						user_id:Number(e.appoint_id),
						ins_type:e.ins_type,
						all_type:e.all_type,
						icon:e.logo,
					}
					this.editIndex = e.id
					if(this.form.sendtype==2){
						if(this.form.all_type==1){
							if(this.form.ins_type==1){
								this.sel_ins = this.ins_1
							}else if(this.form.ins_type==2){
								this.sel_ins = this.ins_2
							}else{
								this.sel_ins = this.ins_list
							}
						}
					}
				}else{
					this.form = {
						id: 0,
						title:'',
						content:"",
						sendtype:0,
						school_id:0,
						ins_id:0,
						user_id:0,
						ins_type:0,
						all_type:0,
						icon:'',
					}
					this.editIndex = -1
				}
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					content:'',
					type:-1,
					all_type:-1,
					ins_type:-1,
					sendtype:-1,
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>


<style>
.dialog-contents{
	max-height: 500px;
    overflow-y: auto;
}
.dialog-meta p {
  margin: 0;
  line-height: 1.5;
}
.dialog-meta p strong {
  margin-right: 5px;
}
.text-success {
  color: green;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}
.el-dialog__body{
	padding-top: 5px;
}
</style>